import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getTaxDetails, clearTaxDetails } from '../../../../redux/Slices/authSlice';

const TaxDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { taxDetails } = useSelector((s) => s.auth);

  useEffect(() => {
    dispatch(getTaxDetails(id));
    return () => {
      dispatch(clearTaxDetails());
    };
  }, [dispatch, id]);

  const tax = taxDetails || {};

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: '20px' }}>تفاصيل الضريبة</h1>
        <button onClick={() => navigate('/taxes')} style={{ background: '#444', color: 'white', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}>
          رجوع
        </button>
      </div>

      <div style={{ background: '#1b3350', border: '1px solid #333', borderRadius: 12, padding: 24 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          <InfoBlock label="الاسم بالعربية" value={tax.name_ar} />
          <InfoBlock label="الاسم بالإنجليزية" value={tax.name_en} />
          <InfoBlock label="النسبة %" value={tax.rate != null ? `${Number(tax.rate)}%` : '—'} />
          <InfoBlock label="الحالة" value={tax.is_active ? 'مفعل' : 'غير مفعل'} />
          <InfoBlock label="تاريخ الإنشاء" value={formatDate(tax.created_at)} />
          <InfoBlock label="تاريخ التحديث" value={formatDate(tax.updated_at)} />
        </div>
      </div>
    </div>
  );
};

const InfoBlock = ({ label, value }) => (
  <div style={{ padding: '12px 0' }}>
    <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>{label}</strong>
    <span style={{ display: 'block', color: '#ccc' }}>{value || '—'}</span>
  </div>
);

const formatDate = (val) => (val ? String(val).split('T')[0] : '—');

export default TaxDetails;


